import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
interface WorkstreamBannerContentProps {
  isNetworkBanner: boolean;
}
function WorkstreamBannerContent(t0) {
  const $ = _c(5);
  const {
    isNetworkBanner
  } = t0;
  const t1 = isNetworkBanner ? "text-primary-foreground" : "text-foreground";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("relative z-10 w-full px-4 pt-4 pb-8 sm:px-6 md:px-10 md:pt-7 md:pb-12 lg:px-16 lg:pb-10.5 xl:px-26 xl:pt-7 xl:pb-9", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex w-full max-w-105 flex-col gap-4 md:max-w-148 md:gap-6 lg:max-w-full xl:max-w-223"><h1 className="text-2xl leading-[120%] font-bold lg:text-3xl">Workstreams</h1><p className="font-semibold lg:text-lg lg:leading-[120%] lg:font-bold xl:text-xl">Find work, submit your proposal and start getting paid for your contributions</p><p className="text-sm/5.5 xl:text-base/6">The Powerhouse finances section offers a complete breakdown of budget and expenditure data for contributor teams since the Network's launch in 2025</p></div>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t2) {
    t4 = <div className={t2}>{t3}</div>;
    $[3] = t2;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}
export { WorkstreamBannerContent };